import React from 'react';
import PropTypes from 'prop-types';

import Badge from '../design_system/Badge';
import { BADGE_COLOR_OPTIONS } from '../design_system/utils/constants';

export default function BadgeList({ titles }) {
  return (
    <div className="BadgeList flex flex-wrap font-14">
      {titles.map(title => (
        <Badge key={title} className="mr2 mb2" color={BADGE_COLOR_OPTIONS.gray}>
          {title}
        </Badge>
      ))}
    </div>
  );
}

BadgeList.propTypes = {
  titles: PropTypes.arrayOf(PropTypes.string).isRequired
};
